import React from "react";
import { StyledTextArea } from "./Styled";

interface TextNoteProps {
    text: string;
    setText: Function;
    style?: any;
}

const TextNote = ({ text, setText, style }: TextNoteProps) => {
    return (

                <StyledTextArea
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    placeholder="Nhập ghi chú đơn hàng tại đây"
                    style={style}
                />
            )}

export default TextNote;
